// DEPENDENCIES //
import { Link } from 'react-scroll';

// IMAGES //
import signature from "../../assets/signature.jpg";
import apsLogo from "../../assets/a_planetary_shift_logo.png";

import Logo from "../Logo";
import studioWordmark from "../../assets/a_planetary_shift_logo_text.png";

// STYLES // 
import "./header.css"
import LogoWordmark from '../LogoWordmark';

export default function Header() {
    return (
        <div id="header">

            {/* <Logo /> */}
            <LogoWordmark
                size={200}
                rotationSpeed={0.03}
                tint={0xcdcdcd}
            />

            <nav>
                <Link className="h_link" to="about" smooth={true} duration={500} offset={-20} >About</Link>
                <Link className="h_link" to="comics" smooth={true} duration={500} offset={-20}>Comics</Link>
                <Link className="h_link" to="games" smooth={true} duration={500} offset={-20}>Games</Link>
                <Link className="h_link" to="tools" smooth={true} duration={500} offset={-20}>Tools</Link>
                <Link className="h_link" to="faq" smooth={true} duration={500} offset={-20}>FAQ</Link>
            </nav>

        </div>
    )
}